export const FEATURE_FLAGS = {
  RICH_TEXT_EDITOR: "RTE",
  TAGS: "TAGS",
  TEMPLATE: "TEMPLATE",
  EXERCISE_EDITOR: "EE",
  MULTI_LANG: "MULTI_LANG",
  PLAYBACK_RATE: "PLAYBACK_RATE",
  POPULATE: "POPULATE",
  GLOBAL_LESSON_TEMPLATES: "GLOBAL_LESSON_TEMPLATES",
  SUPER_ADMIN: "SUPER_ADMIN",
  ADMIN: "ADMIN",
  INDEX_REFERENCES: "INDEX_REFERENCES",
  EDIT_CONTENT: "EDIT_CONTENT",
  PORTAL_V2: "PORTAL_V2",
  PLAYLIST: "PLAYLIST",
  TTS_INSTRUCTIONS: "TTS_INSTRUCTIONS",
  PDF_DEBUG: "PDF_DEBUG",
  STEMPROFIEL: "STEMPROFIEL",
  ORGANIZATION_USE: "ORGANIZATION_USE",
  ORGANIZATION_CREATE: "ORGANIZATION_CREATE",
  ORGANIZATION_ADMIN: "ORGANIZATION_ADMIN",
  EMAIL_TEMPLATES: "EMAIL_TEMPLATES",
  MCP_ACCESS: "MCP_ACCESS",
  USER_REVISIONS: "USER_REVISIONS",
} as const;

